import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TextFieldProps } from '@material-ui/core';
import MuiPhoneNumber from 'material-ui-phone-number';

const useStyles = makeStyles((theme: any) => ({
  textField: {
    width: 300,
    marginBottom: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto',
    '& .MuiOutlinedInput-adornedStart': {
      borderRadius: theme.spacing(1.5),
    },
  },
}));

interface Props {
  errors?: any;
  label?: string;
  name?: string;
  TextFieldProps?: Partial<TextFieldProps>;
  InputProps?: any;
  className?: any;
  setValue: any;
}

//TODO: need to add to storybook
export default function PhoneInputField({
  errors = {},
  label,
  name,
  TextFieldProps,
  InputProps = null,
  className = null,
  setValue,
}: Props) {
  const classes = useStyles();

  return (
    <>
      <MuiPhoneNumber
        className={classes.textField + ' ' + className}
        fullWidth
        name={name}
        id={label}
        label={label}
        variant="outlined"
        defaultCountry={'us'}
        disableAreaCodes
        error={errors[name] ? true : false}
        helperText={errors[name] ? errors[name].message : null}
        {...TextFieldProps}
        InputProps={{ ...InputProps, disableUnderline: true }}
        onChange={(value) => setValue(name, value)}
      />
    </>
  );
}
